import stateOptions from './state-options';
export const stateList = Object.keys(stateOptions);
/**
 * normalize the users state, case insensitive
 */
export default (state) => {
    if (!state) {
        return;
    }
    // if the input is abbr, return it
    const upper = state.toUpperCase();
    if (stateOptions[upper]) {
        return upper;
    }
    // otherwise, iterate the list to find the abbr
    for (const [abbr, full] of Object.entries(stateOptions)) {
        if (full.toUpperCase() === upper) {
            return abbr;
        }
    }
};
